import React from 'react';
import { TextField, Typography } from '@mui/material';
import { COLOR } from '@src/styles/color';
import ArrowDropDownRounded from '@src/assets/icons/ArrowDropDownRounded.svg';
import { StyledSelect, StyledMenuItem } from './index.style';

const Select = ({
  label,
  name,
  value = '',
  placeholder = '',
  onChange,
  error = false,
  helperText = '',
  disabled = false,
  options = [],
  getOptionLabel = (option) => option?.label,
  getOptionValue = (option) => option?.value,
  customStyle,
  menuProps,
  ...props
}) => (
  <StyledSelect customStyle={customStyle}>
    <Typography className="input-label">{label}</Typography>
    <TextField
      name={name}
      value={value}
      placeholder={placeholder}
      size="small"
      fullWidth
      select
      disabled={disabled}
      onChange={onChange}
      error={error}
      displayEmpty
      InputLabelProps={{
        shrink: true,
      }}
      SelectProps={{
        displayEmpty: true,
        MenuProps: menuProps,
        renderValue: (selected) => {
          if (!selected || selected === '') {
            return (
              <span style={{ color: COLOR.label2[48] }}>{placeholder}</span>
            );
          }
          const option = options.find(
            (item) => getOptionValue(item) === selected,
          );
          return getOptionLabel(option);
        },
        IconComponent: (element) => (
          <img
            {...element}
            src={ArrowDropDownRounded}
            alt=""
            style={{
              padding: '0 12px',
              right: '0px',
              top: 'calc(50% - 12px)',
              opacity: disabled ? 0.5 : 1,
            }}
          />
        ),
      }}
      sx={{
        '& .MuiFormHelperText-root': {
          marginLeft: 0,
          marginTop: '8px',
        },
      }}
      {...props}
    >
      {options.map((item) => (
        <StyledMenuItem key={getOptionValue(item)} value={getOptionValue(item)}>
          {getOptionLabel(item)}
        </StyledMenuItem>
      ))}
    </TextField>
    {error && <Typography className="input-error">{helperText}</Typography>}
  </StyledSelect>
);

export default Select;
